export const GET_ALL_COMMENTS_REQUEST = 'GET_ALL_COMMENTS_REQUEST'
export const GET_ALL_COMMENTS_SUCCESS = 'GET_ALL_COMMENTS_SUCCESS'
export const GET_ALL_COMMENTS_FAIL = 'GET_ALL_COMMENTS_FAIL'
